module.exports = __webpack_public_path__ + "img/indicator3b_v2.e1ffcfbd.svg";